import { useEffect, useState } from 'react';

import { CollectiveMembersResponse } from '../types';
import { apiOrchestrator } from 'services/apiService';

type Params = {
  page?: number;
  size?: number;
  user_reference?: string;
  relationship_status?: 'RECEIVED_PENDING' | 'SENT_PENDING' | 'PENDING' | 'ACCEPTED' | 'REJECTED';
  refreshTrigger?: number;
  [key: string]: any;
};

export const useCollectiveMembers = (params: Params = {}) => {
  const [data, setData] = useState<CollectiveMembersResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError(null);

    const fetchMembers = async () => {
      try {
        const response = await apiOrchestrator.get('/users-person/find', {
          params,
        });
        if (isMounted) {
          setData(response.data);
        }
      } catch (err) {
        if (isMounted) setError(err as Error);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchMembers();
    return () => {
      isMounted = false;
    };
  }, [JSON.stringify(params)]);

  return { data, isLoading, error };
};
